import { useQuery } from 'react-query';
import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';

import { Form, FormSchemaResponse } from '@common/types/api';
import { FORMS_ENDPOINT } from '@constants/endpoints';
import { api } from '@services';

export const fetchFormSchema = async (slug: string): Promise<Form | null> => {
  try {
    const { data } = await api.get<FormSchemaResponse>(
      FORMS_ENDPOINT.SCHEMA(slug),
    );
    return data.data;
  } catch (error) {
    const axiosError = error as AxiosError;
    // Return null for 404 (form not found) - this is expected
    if (axiosError.response?.status === 404) {
      return null;
    }
    throw error;
  }
};

export const useFormSchemaQuery = (slug: string, enabled = true) => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language || 'br';

  return useQuery<Form | null, AxiosError, Form | null>(
    ['form-schema', slug, currentLang],
    () => fetchFormSchema(slug),
    {
      enabled: !!slug && enabled,
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: false, // Don't retry on errors - form may not exist
    },
  );
};
